// src/language/salesLanguage.js
const salesLanguage = {
  en: {
    pageTitle: "Sales",

    // Fields
    saleProductName: "Product Name",
    amount: "Amount (₹)",
    date: "Date",
    save: "Save",
    update: "Update",
    cancel: "Cancel",

    // Table headers
    recentSales: "Recent Sales",
    colDate: "Date",
    colProduct: "Product Name",
    colAmount: "Amount (₹)",
    colActions: "Actions",

    // Messages
    validationError: "Validation Error",
    success: "Success",
    error: "Error",
    savedSuccess: "Sale entry saved successfully!",
    updatedSuccess: "Sale entry updated successfully!",
    deletedSuccess: "Sale entry deleted successfully!",
    saveFailed: "Failed to save sale entry.",
    deleteFailed: "Failed to delete sale entry.",
    deleteConfirmTitle: "Delete Sale",
    deleteConfirmMsg: "Are you sure you want to delete this sale entry? This action cannot be undone.",
    salesValidation: "Please enter product name and amount.",
    saving: "Saving...",
    noEntries: "No sales entries yet.",
    delete: "Delete",
    deleteCancel: "Cancel",
  },
  mr: {
    pageTitle: "विक्री",

    // Fields
    saleProductName: "उत्पादनाचे नाव",
    amount: "रक्कम (₹)",
    date: "तारीख",
    save: "सेव्ह करा",
    update: "अपडेट करा",
    cancel: "रद्द करा",

    // Table headers
    recentSales: "अलीकडील विक्री",
    colDate: "तारीख",
    colProduct: "उत्पादनाचे नाव",
    colAmount: "रक्कम (₹)",
    colActions: "क्रिया",

    // Messages
    validationError: "प्रमाणीकरण त्रुटी",
    success: "यशस्वी",
    error: "त्रुटी",
    savedSuccess: "विक्री नोंद यशस्वीरित्या जतन केली!",
    updatedSuccess: "विक्री नोंद यशस्वीरित्या अपडेट केली!",
    deletedSuccess: "विक्री नोंद यशस्वीरित्या हटवली!",
    saveFailed: "विक्री नोंद जतन करण्यात अयशस्वी.",
    deleteFailed: "विक्री नोंद हटवण्यात अयशस्वी.",
    deleteConfirmTitle: "विक्री नोंद हटवा",
    deleteConfirmMsg: "तुम्हाला खात्री आहे की तुम्ही ही विक्री नोंद हटवू इच्छिता? ही क्रिया परत घेता येत नाही.",
    salesValidation: "कृपया उत्पादनाचे नाव आणि रक्कम भरा.",
    saving: "जतन करत आहे...",
    noEntries: "अद्याप कोणत्याही विक्री नोंदी नाहीत.",
    delete: "हटवा",
    deleteCancel: "रद्द करा",
  },
};

export default salesLanguage;
